import useFormulesOrders from "@/Pages/Auth/Bestellingen/Live/useFormulesOrders";
import useOrdersQuery from "../v2/queries/useOrdersQuery";
import useIsMergeHook from "./useIsMergeHook";

const useOrders = (customMerge = undefined) => {
  const isMerge = useIsMergeHook();
  const formules = useFormulesOrders();
  const query = useOrdersQuery();
  const isFormules = customMerge === undefined ? isMerge : customMerge === true;
  return isFormules ? formules : query;
};

export default useOrders;
